export const ui = {
    attachments: document.querySelector('.attachments-slider.swiper'),
    worksLikeYou: document.querySelector('.works-like-you__images.swiper')
};
